import React from 'react'
import './styles.css'

const LoadingBar: React.FC<{className?: string}> = ({ className }) =>
  <div className={`LoadingBar${className ? (' ' + className) : ''}`}>
    <div />
  </div>

export default LoadingBar
